var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    // SHAPE
    {
      'h-[0.5px]': _vm.orientation === _vm.OzDividerOrientation.Horizontal,
      'w-[0.5px]': _vm.orientation === _vm.OzDividerOrientation.Vertical,
    },

    // COLOR
    _vm.colorScheme === _vm.OzDividerColorScheme.Solid && [
      {
        'bg-divider-gray dark:bg-divider-gray-dark': _vm.darkMode === 'auto',
        'bg-divider-gray': _vm.darkMode === false,
        'bg-divider-gray-dark': _vm.darkMode === true,
      },
    ],
    _vm.colorScheme === _vm.OzDividerColorScheme.Translucent && [
      'bg-opacity-30',
      {
        'bg-grey-200 dark:bg-white-400': _vm.darkMode === 'auto',
        'bg-grey-200': _vm.darkMode === false,
        'bg-white-400': _vm.darkMode === true,
      },
    ],
  ]})
}
var staticRenderFns = []

export { render, staticRenderFns }